export enum routes {
  LOGIN = '/login',
  HOME = '/dashboard',
  PAGE_NOT_FOUND = '/404',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  TICKETS = '/tickets',
  TRAINING = '/training',
  PRODUCTS = '/products',
  ADD_PRODUCT = '/products/add',
  EDIT_PRODUCT = '/products/edit',
  SETTINGS = '/settings',
  NEW_TICKET = '/tickets/new',
  TICKET_DETAILS = '/tickets/:ticketId',
  ASSIGN = '/assign',
  REASSIGN = '/reassign',
  RESOLVE = '/resolve',
  EDIT_PARAMETERS = '/edit-parameters',
  ERROR_INDEX = '/products/error-index',
  SERVICE_ACCOUNTS = '/service-accounts',
  NEW_SERVICE_ACCOUNT = '/service-accounts/new',
  EDIT_SERVICE_ACCOUNT = '/service-accounts/edit',
  MANUFACTURER_ACCOUNTS = '/manufacturer-accounts',
  NEW_MANUFACTURER_ACCOUNT = '/manufacturer-accounts/new',
  EDIT_MANUFACTURER_ACCOUNT = '/manufacturer-accounts/edit',
  COMPANIES = '/companies',
  NEW_COMPANY = '/companies/new',
  EDIT_COMPANY = '/companies/edit',
  AUTO_ASSIGN = '/auto-assign',
}
